import { cellLineaRazonSocial, cellNotFilter, emptyCell, formatDateWithTimeCell } from "@/shared";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

export default function useTableColumnsSolicitudTecnicoPymes() {

  const columnaSolicitudTecnicoPymes = useMemo<MRT_ColumnDef<IPreagendamientoPymes>[]>(
    () => [
      {
        accessorKey: 'cliente_razon_social',
        header: 'Nombre',
        size: 300,
        Cell: ({ row }) => (
          cellLineaRazonSocial(row.original.contrato_data, row.original.prospecto_pymes_data.razon_social)
        ),
      },
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        size: 180,
        Cell: ({ row }) =>
          row.original?.prospecto_pymes_data?.identificacion || 'N/A',
      },

      {
        accessorKey: 'nombre_enlace',
        header: 'Nombre Enlace',
        size: 180,
        Cell: ({ row }) =>
          row.original?.nombre_enlace || 'N/A',
      },
      {
        accessorKey: 'observacion_tecnico_adicional',
        header: 'Observación',
        size: 350,
        Cell: ({ row }) => (
          emptyCell(row.original.observaciones?.observacion_tecnico_adicional)
        )
      },
      // -------------
      {
        ...cellNotFilter,
        accessorKey: 'direccion',
        header: 'direccion',
        size: 300,
        Cell: ({ row }) => row.original?.preventa_pymes_data?.direccion || 'N/A',
      },
      {
        ...cellNotFilter,
        accessorKey: 'fecha_hora_instalacion',
        header: 'FECHA Y HORA INSTALACION',
        size: 210,
        enableColumnFilter: true,
        enableSorting: true,
        Cell: ({ row }) =>
          `${row.original.fecha_instalacion} ${row.original.hora_instalacion}`,
      },
      /* {
        accessorKey: 'coordenadas',
        header: 'COORDENADAS',
        size: 210,
        Cell: ({ row }) => emptyCellOneLevel(row, 'coordenadas'),
      }, */
      // flota & nap ------------------
      {
        accessorKey: 'flota',
        header: 'FLOTA',
        size: 180,
        Cell: ({ row }) => row.original?.flota_data?.nombre || 'N/A',
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'Fecha de Creación',
        size: 200,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion'),
      },
      {
        accessorKey: 'fecha_modificacion',
        header: 'Fecha de Modificación',
        size: 200,
        enableColumnFilter: true,
        filterVariant: 'date',
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_modificacion'),
      },
    ],
    []
  );

  return {
    columnaSolicitudTecnicoPymes
  }
}